import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Spline from '../spline.js';

export default class NodeCreateArc extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.FLOAT, 'radius_x', 0.5, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'radius_y', 0.5, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.BOOLEAN, 'circle', true);
		this.addInput(PARAM_TYPE.FLOAT, 'start_angle', 0, { minValue: 0, maxValue: 360, units: PARAM_UNITS.DEGREES });
		this.addInput(PARAM_TYPE.FLOAT, 'end_angle', 360, { minValue: 0, maxValue: 360, units: PARAM_UNITS.DEGREES });

		this.addInput(PARAM_TYPE.FLOAT, 'roughness', 0.01, { minValue: 0.001, maxValue: 0.2 });

		this.addInput(PARAM_TYPE.FLOAT, 'center_x', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'center_y', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}

	getType()
	{
		return 'createArc';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		const lastCircResult = this.getLastInputResult('circle');
		if(strInputName == 'radius_y' && lastCircResult)
			return false;

		return true;
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		const fRadiusY = inputValues['circle'] ? inputValues['radius_x'] : inputValues['radius_y'];
		const vecCenter = new BABYLON.Vector2(inputValues['center_x'], inputValues['center_y']);
		let pSpline = Spline.createArc(inputValues['radius_x'], fRadiusY, inputValues['start_angle'], inputValues['end_angle'], vecCenter, inputValues['roughness']);
		return pSpline.saveToObject();
	}
}